export default __webpack_public_path__ + "locales/zh-CN/SendInviteDialog.json?hash=5a93c62eb3a79ef5f07ff12f36be4614";